/**
 * @architecture-header 1
 * @layer shared
 * @domain workspace-state
 * @responsibility Let a successful organization-identity edit (SET-F04) notify unrelated
 *   already-mounted readers of that identity (the rail switcher) to refetch, without a shared
 *   TanStack Query cache entry between them.
 * @state-owner module-scoped listener registry
 * @allowed-imports TypeScript standard library
 * @forbidden API entities; roles; permissions; tokens; React; localStorage
 * @public-api SET-F04 organization mutation; WorkspaceSwitcher
 * @side-effects invokes registered listeners
 * @tests workspace-identity-refresh.test.ts
 */

const listeners = new Set<() => void>();

export function registerWorkspaceIdentityRefresh(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyWorkspaceIdentityRenamed(): void {
  for (const listener of listeners) listener();
}
